/**
 * @description: 共享股东提现明细报表
 * @author: lyr
*/
<template>
    <div class="mr-ggtm-report">
        <div class="list" v-show="!showDetail">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="list_form.content">
                        <el-select class="el-slot-select" v-model="list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="股东卡号" value="vip_card"></el-option>
                            <el-option label="股东手机号" value="vip_mobile"></el-option>
                            <el-option label="股东姓名" value="vip_name"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="会员等级">
                    <el-select v-model="list_form.level" filterable clearable placeholder="请选择会员等级">
                        <el-option v-for="item in vip_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提现方式">
                    <el-select v-model="list_form.type" filterable clearable placeholder="请选择提现方式">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="自助提现" value="1"></el-option>
                        <el-option label="线下提现" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-input v-model="list_form.admin_name" clearable placeholder="请输入操作人"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-input v-model="status_str" clearable placeholder="请选择状态" readonly @click.native="openStatusChoosePop"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listtExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">提现总额：{{amount_total}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="提现时间"></el-table-column>
                <el-table-column prop="vip_level_name" label="会员等级"></el-table-column>
                <el-table-column prop="vip_card" label="股东卡号"></el-table-column>
                <el-table-column prop="mobile" label="股东手机号"></el-table-column>
                <el-table-column prop="username" label="股东姓名"></el-table-column>
                <el-table-column prop="before_remain_total_bonus" label="提现之前分红余额"></el-table-column>
                <el-table-column prop="amount" label="提现金额"></el-table-column>
                <el-table-column prop="remain_total_bonus" label="提现之后余额"></el-table-column>
                <el-table-column prop="type_name" label="提现方式"></el-table-column>
                <el-table-column prop="status_name" label="状态"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 状态选择 -->
        <div class="status-pop ele-hide" ref="status_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllStatus" @change="handleCheckAllStatusChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.status" @change="handleCheckStatusChange">
                    <el-checkbox v-for="item in status_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'ggtm-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                vip_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_card',
                    level: '',
                    type: '', // 1自助提现 2线下提现
                    admin_name: '',
                    status: [], // 状态 1已领取 -1未领取 -2已退回
                },
                status_list: [{
                    id: '1',
                    name: '已领取'
                }, {
                    id: '-1',
                    name: '未领取'
                }, {
                    id: '-2',
                    name: '已退回'
                }],
                checkAllStatus: false,
                amount_total: 0, // 提现总额
                list_table: [],
                list_page: 1,
                list_total: 0,
                showDetail: false,
            }
        },
        computed: {
            status_str() {
                if (this.list_form.status.length == 0) {
                    return ''
                }else if(this.list_form.status.length == this.status_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.status.forEach(v => {
                        this.status_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            }
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if (val.params.vip_card) {
                        this.list_form = {
                            start_time: '',
                            end_time: '',
                            shop_id: '',
                            content: this.$route.params.vip_card,
                            select: 'vip_card',
                            level: '',
                            type: '', // 1自助提现 2线下提现
                            admin_name: '',
                            status: [], // 状态 1已领取 -1未领取 -2已退回
                        }
                        this.getList(1);
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();

            // 页面跳转第一次打开
            if(this.$route.params.vip_card) {
                this.list_form = {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: this.$route.params.vip_card,
                    select: 'vip_card',
                    level: '',
                    type: '', // 1自助提现 2线下提现
                    admin_name: '',
                    status: [], // 状态 1已领取 -1未领取 -2已退回
                }
            }

            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                if (this.$route.params.vip_card) { // 页面跳转第一次打开
                    this.list_form.shop_id = ''
                }else {
                    this.list_form.shop_id = this.shop_list[0].id;
                    this.setShopDefaultTime(this.shop_list[0].id)
                }
                this.getVipLevelCombo()
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },

            // 获取会员卡等级
            getVipLevelCombo: function() {
                const _this = this;

                Vue.axios.post('Vip/getVipLevelCombo', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.vip_list = res.data.response.result;
                        _this.vip_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 打开状态选择弹窗
            openStatusChoosePop() {
                let _this = this
                let c_status = _this.list_form.status
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择状态', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.status_pop),
                    cancel: function() {
                        _this.list_form.status = c_status
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.status = c_status
                    layer.closeAll()
                });
            },

            // 状态全选
            handleCheckAllStatusChange(val) {
                this.list_form.status = []
                this.checkAllStatus = val
                if (val) {
                    this.status_list.forEach(item => {
                        this.list_form.status.push(item.id)
                    })
                }
            },

            // 选择状态
            handleCheckStatusChange(val) {
                this.checkAllStatus = val.length === this.status_list.length
            },

            getList(page) {
                const _this = this;

                _this.loading = true;
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(_this.list_form.select == 'vip_card') {
                    vip_card = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_name') {
                    username = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_mobile') {
                    mobile = _this.list_form.content;
                }
                Vue.axios.post('FinanceReport2/getVipShareholderWithdrawalList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "level": _this.list_form.level,
                            "type": _this.list_form.type,
                            "admin_name": _this.list_form.admin_name,
                            "status": _this.list_form.status
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.list_total = Number(res.data.response.result.data.total);
                            _this.amount_total = res.data.response.result.data.amount_total;
                        }
                        _this.list_table = res.data.response.result.data.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 查询
            listQuery() {
                this.list_page = 1
                this.getList(this.list_page);
            },

            listtExport: function() {
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(this.list_form.select == 'vip_card') {
                    vip_card = this.list_form.content;
                } else if(this.list_form.select == 'vip_name') {
                    username = this.list_form.content;
                } else if(this.list_form.select == 'vip_mobile') {
                    mobile = this.list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/exportVipShareholderWithdrawalList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&vip_card=" + vip_card +
                    "&username=" + username +
                    "&mobile=" + mobile +
                    "&level=" + this.list_form.level +
                    "&type=" + this.list_form.type + 
                    "&admin_name=" + this.list_form.admin_name +
                    "&status=" + this.list_form.status;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .status-pop {
        .el-checkbox {
            margin-bottom: 10px;
        }
    }
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }
</style>